import {groupRiskStatus} from '../../../util/uiconstants';
import selectComponentRisks from './selectComponentRisks';

export default () =>
	selectComponentRisks()?.filter(({relatedComponentRisks, groupRiskStatusId}) => {
		const isRelated = relatedComponentRisks?.length === 0;
		const hasValidStatus =
			groupRiskStatusId === groupRiskStatus.notApplicable || groupRiskStatusId === groupRiskStatus.unmapped;
		return isRelated && hasValidStatus;
	}) ?? [];
